<template>
  <v-container
    fluid
    class="pa-8">
    <v-row>
      <v-col>
        <span
          class="base-title">
          Logs da Integradora
        </span>
      </v-col>
      <v-col
        cols="12">
        <v-data-table
          class="elevation-1"
          item-key="id"
          :headers="headers"
          :items="logs"
          :loading="loadingLogs"
          :items-per-page="10"
          disable-sort>
          <template v-slot:no-data>
            <span>
              Nenhum log encontrado.
            </span>
          </template>
          <template v-slot:[`item.id`]="{ item }">
            {{ item.id ? item.id : '-' }}
          </template>
          <template v-slot:[`item.date`]="{ item }">
            {{
              item.createdAt
              ? moment(item.createdAt, 'YYYY-MM-DD HH:mm:ss').format('DD/MM/YYYY HH:mm')
              : '-'
            }}
          </template>
          <template v-slot:[`item.message`]="{ item }">
            {{ item.message ? item.message : '-' }}
          </template>
          <template v-slot:[`item.status`]="{ item }">
            <v-sheet
              dense
              rounded="lg"
              color="muted-foreground"
              class="pa-1 d-flex align-center justify-center primary--text font-weight-medium">
              {{ item.status ? getLogStatusName(item.status) : '-' }}
              <v-icon
                class="ml-2"
                color="warning"
                size="14"
                v-if="item.status === 'ERROR'">
                fas fa-exclamation-triangle
              </v-icon>
            </v-sheet>
          </template>
          <template v-slot:[`item.action`]="{ item }">
            <v-btn
              icon
              color="primary"
              @click="showLog(item)">
              <v-icon>
                mdi mdi-console-line
              </v-icon>
            </v-btn>
          </template>
        </v-data-table>
      </v-col>
      <v-col
        cols="12"
        class="d-flex justify-end">
        <v-btn
          x-large
          width="200"
          outlined
          color="primary--text"
          @click="toGoBack">
          Voltar
        </v-btn>
      </v-col>
    </v-row>

    <SnackbarCustomize ref="SnackbarCustomize" />
    <LogModal ref="LogModal" />
  </v-container>
</template>

<script>
import IntegratorMovementsMixin from '@/shared/mixins/integratorMovements/IntegratorMovementsMixin';
import IntegratorMovementService from '@/services-http/sdi/IntegratorMovementService';
import VerifyRoutesMixin from '@/shared/mixins/routeManagement/verifyRoutesMixin';
import SnackbarCustomize from '@/components/CustomAlerts/SnackbarCustomize.vue';
import LogModal from '@/components//Modals/LogModal/LogModal.vue';
import moment from 'moment';

export default ({
  name: "ApiLog",

  components: {
    SnackbarCustomize,
    LogModal,
  },

  data: () => ({
    moment,
    loadingLogs: false,
    isRHProtegido: false,
    integratorMovementService: null,
    headers: [
      {
        text: 'Protocolo',
        value: 'id',
        align: 'start',
      },
      {
        text: 'Horário',
        value: 'date',
        align: 'start',
      },
      {
        text: 'Mensagem',
        value: 'message',
        align: 'start',
      },
      {
        text: 'Status',
        value: 'status',
        width: '200px',
        align: 'start',
      },
      {
        text: 'Ação',
        value: 'action',
        align: 'start',
      },
    ],
    logs: [],
  }),

  mixins: [
    IntegratorMovementsMixin,
    VerifyRoutesMixin,
  ],

  methods: {
    showLog(log) {
      this.$refs.LogModal.open(log);
    },
    loadLogs() {
      this.loadingLogs = true;
      const { id } = this.$route.params;

      this.loadMovementIntegratorLogs(id);
    },
    async loadMovementIntegratorLogs(movementRecordId) {
      await this.integratorMovementService.FetchIntegrationMovementLogs(movementRecordId)
      .then((response) => response.data)
      .then((result) => {
        if (Array.isArray(result) && result.length > 0) {
          this.logs = result;
        }
      }).catch(() => {
        this.$refs.SnackbarCustomize.open('error', 'Erro ao buscar logs da integradora. Tente novamente');
      }).finally(() => this.loadingLogs = false);
    },
    toGoBack() {
      const selectedDate = sessionStorage.getItem('selectedDate');
      const searchParams = sessionStorage.getItem('selectedDate');

      const queryParams = {
        ...searchParams,
        selectedDate,
        tab: 'integratorMovements',
      };

      sessionStorage.setItem('searchParams', JSON.stringify(queryParams));

      this.$router.push({ name: 'Movement', query: { isRHProtegido: `${this.isRHProtegido}` } });
    },
  },

  created() {
    this.integratorMovementService = new IntegratorMovementService();
  },

  mounted() {
    this.verifyRouteRHProtegidoMixin();
    this.loadLogs();
  },
});
</script>
